<script setup lang="ts">
import type { BeltColor } from '@@/bits/belt_colors'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import { computed } from 'vue'

const props = defineProps<{
  color: BeltColor
  isDarkMode: boolean
}>()

// Intrinsic source dimensions, kept for the aspect ratio.
const BACKGROUND_IMAGE_WIDTH = 1856
const BACKGROUND_IMAGE_HEIGHT = 1044
// Faint full-bleed decorative backdrop: fetch it small to stay within the dashboard image byte budget.
const BACKGROUND_FETCH_WIDTH = 640
const BACKGROUND_FETCH_HEIGHT = 360

const backgroundIllustrationUrl = computed(() => {
  if (props.color === 'white') {
    return 'https://padlet.net/dashboard/belt/v4_certificate_background_illustration_white.png'
  }
  return `https://padlet.net/dashboard/belt/v4_certificate_background_illustration_${props.color}_${props.isDarkMode ? 'dark' : 'light'}.png`
})
</script>

<script lang="ts">
export enum BackgroundIllustrationDisplayMode {
  Cover = 'cover',
  Fill = 'fill',
  FitWidth = 'fit-width',
}

export default {}
</script>

<template>
  <div class="relative w-full h-full overflow-hidden">
    <!-- Use object to avoid blur rendering issues on iOS -->
    <ImageThumbnail
      :fetch-priority="'high'"
      :lazy-loading="false"
      :process-image="true"
      :src="backgroundIllustrationUrl"
      :original-image-width="BACKGROUND_IMAGE_WIDTH"
      :original-image-height="BACKGROUND_IMAGE_HEIGHT"
      :width="BACKGROUND_FETCH_WIDTH"
      :height="BACKGROUND_FETCH_HEIGHT"
      :resize-strategy="'fit'"
      alt=""
    />
  </div>
</template>
